import React from 'react';

const FamilyIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      style={{
        height: '30'
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 79.54 68.69"
        height="30"
      >
        <path
          d="M22.05,5.85A5.85,5.85,0,1,1,16.2,0,5.84,5.84,0,0,1,22.05,5.85ZM16.82,45.79l1.26,21.52a1.37,1.37,0,1,0,2.73,0L22,45.79h3.81L21.85,21.66l7.93,15.78a1.37,1.37,0,1,0,2.52-1.07s-5.81-15.7-7.24-18.62S22.21,13,16.76,13H15.65c-5.44,0-6.87,1.77-8.29,4.71S.11,36.37.11,36.37a1.37,1.37,0,1,0,2.52,1.07l7.93-15.78L6.62,45.79h3.8L11.6,67.31a1.38,1.38,0,1,0,2.75,0l1.17-21.52ZM63.33,0a5.84,5.84,0,1,0,5.83,5.83A5.85,5.85,0,0,0,63.33,0Zm6,34.33.39-12.69,7.12,15.79a1.38,1.38,0,0,0,2.54-1.08s-5-15.7-6.45-18.62S69.33,13,63.89,13H62.77c-5.44,0-7.65,1.77-9.09,4.7s-6.44,18.62-6.44,18.62a1.36,1.36,0,0,0,.72,1.8,1.35,1.35,0,0,0,1.79-.72l7.14-15.79.38,12.69-1.12,31.9a2.31,2.31,0,0,0,2.12,2.45h.17a2.3,2.3,0,0,0,2.29-2.14l2.59-26.27,2.61,26.27a2.29,2.29,0,0,0,2.28,2.14h.16a2.29,2.29,0,0,0,2.12-2.45l-1.12-31.9ZM39.77,35.46A3.58,3.58,0,1,0,43.35,39,3.59,3.59,0,0,0,39.77,35.46Zm0,21.08,1.61,11.2a1.45,1.45,0,0,0,2.74-.06,4.29,4.29,0,0,0,0-.81l-.66-13.75.21-4.73c.18-1.61.22-1.13,2-2.22s5-6,5.19-6.28a3.73,3.73,0,0,0,.49-1,.92.92,0,0,0-.72-1.07,1.06,1.06,0,0,0-.93.4c-.24.26-3.89,5.12-6.63,5.59a11.77,11.77,0,0,0-3-.42h-.69a11.94,11.94,0,0,0-3,.42c-2.74-.47-6.39-5.33-6.65-5.59a1,1,0,0,0-.91-.4.92.92,0,0,0-.72,1.07,3.47,3.47,0,0,0,.5,1c.16.24,3.33,5.16,5.19,6.28s1.87.61,2,2.22l.2,4.73-.65,13.75a3.54,3.54,0,0,0,0,.81,1.43,1.43,0,0,0,2.72.06l1.62-11.2"
          fill="currentColor"
        />
      </svg>
    </span>
  );
};

const SingleParentIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      style={{
        height: '30'
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 51.43 68.67"
        height="30"
      >
        <path
          d="M22.05,5.83A5.85,5.85,0,1,1,16.2,0,5.84,5.84,0,0,1,22.05,5.83Zm-5.23,40L18.08,67.3a1.37,1.37,0,1,0,2.73,0L22,45.77h3.81L21.85,21.64l7.93,15.78a1.37,1.37,0,0,0,1.79.74,1.38,1.38,0,0,0,.73-1.8s-5.81-15.7-7.24-18.63S22.21,13,16.76,13H15.65c-5.44,0-6.87,1.78-8.29,4.71S.11,36.36.11,36.36a1.37,1.37,0,1,0,2.52,1.06l7.93-15.78L6.62,45.77h3.8L11.6,67.3a1.38,1.38,0,0,0,2.75,0l1.17-21.53Zm23-10.33A3.58,3.58,0,1,0,43.35,39,3.59,3.59,0,0,0,39.77,35.45Zm0,21.08s1.61,11.18,1.61,11.19a1.45,1.45,0,0,0,1.36,1,1.48,1.48,0,0,0,1.38-1,4.28,4.28,0,0,0,0-.81L43.47,53.1l.21-4.73c.18-1.6.22-1.12,2-2.21s5-6,5.19-6.28a3.79,3.79,0,0,0,.49-1,.91.91,0,0,0-.72-1.06,1,1,0,0,0-.93.39c-.24.27-3.89,5.13-6.63,5.59a11.94,11.94,0,0,0-3-.41h-.69a12.62,12.62,0,0,0-3,.41c-2.74-.46-6.39-5.32-6.65-5.59a1,1,0,0,0-.91-.39.91.91,0,0,0-.72,1.06,3.53,3.53,0,0,0,.5,1c.16.23,3.33,5.16,5.19,6.28s1.87.61,2,2.21l.2,4.73-.65,13.75a3.51,3.51,0,0,0,0,.81,1.43,1.43,0,0,0,2.72.06s1.62-11.19,1.62-11.19"
          fill="currentColor"
        />
      </svg>
    </span>
  );
};

const SoloIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      style={{
        height: '30'
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32.41 68.69"
        height="30"
      >
        <path
          d="M16.21,0A5.84,5.84,0,1,0,22,5.83,5.84,5.84,0,0,0,16.21,0Zm6,34.33.39-12.69,7.13,15.79a1.38,1.38,0,0,0,2.53-1.08s-5-15.7-6.45-18.62S22.2,13,16.76,13H15.64C10.2,13,8,14.8,6.55,17.73S.11,36.35.11,36.35a1.37,1.37,0,0,0,.72,1.8,1.35,1.35,0,0,0,1.79-.72L9.76,21.64l.38,12.69L9,66.23a2.31,2.31,0,0,0,2.12,2.45h.17a2.32,2.32,0,0,0,2.3-2.14l2.58-26.27,2.62,26.27a2.27,2.27,0,0,0,2.27,2.14h.16a2.3,2.3,0,0,0,2.13-2.45l-1.13-31.9Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
};

const PersonIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      style={{
        height: '30'
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 249.53 344.43"
        height="30"
      >
        <path
          d="M124.78,146.39A73.2,73.2,0,1,0,51.57,73.2,73.2,73.2,0,0,0,124.78,146.39Z"
          fill="currentColor"
        />
        <path
          d="M155.83,151.38H93.72A93.82,93.82,0,0,0,0,245.1v76l.19,1.19,5.23,1.63c49.32,15.41,92.17,20.55,127.43,20.55,68.88,0,108.81-19.64,111.27-20.89l4.89-2.47h.52v-76A93.79,93.79,0,0,0,155.83,151.38Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
};

const EntityIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      style={{
        height: '30'
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 499.08 420"
        height="30"
      >
        <path
          d="M301.17,72.09a90.69,90.69,0,0,1,42.21,67.37,73.16,73.16,0,1,0-42.21-67.37ZM253.22,222A73.2,73.2,0,1,0,180,148.77,73.2,73.2,0,0,0,253.22,222Zm31,5H222.16a93.83,93.83,0,0,0-93.72,93.73v75.95l.2,1.19,5.23,1.64C183.18,414.86,226,420,261.29,420c68.88,0,108.81-19.64,111.27-20.89l4.89-2.47H378v-76A93.8,93.8,0,0,0,284.27,226.94Zm121.1-75.56H343.74a90.21,90.21,0,0,1-27.84,62.83,111.37,111.37,0,0,1,79.54,106.57v23.41c60.85-2.23,95.92-19.48,98.23-20.64l4.89-2.48h.52v-76A93.82,93.82,0,0,0,405.37,151.38Zm-280.58-5a72.66,72.66,0,0,0,38.92-11.3,90.61,90.61,0,0,1,34-57.77c.08-1.37.21-2.73.21-4.12a73.19,73.19,0,1,0-73.18,73.19Zm65.73,67.81a90.21,90.21,0,0,1-27.82-62.48c-2.29-.17-4.55-.35-6.88-.35H93.72A93.82,93.82,0,0,0,0,245.09v76l.19,1.17,5.23,1.65C45,336.23,80.3,341.93,111,343.72V320.78A111.38,111.38,0,0,1,190.52,214.21Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
};

const StandardIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      style={{
        height: '30'
      }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 224 420" height="30">
        <path
          d="M217,0H7A7,7,0,0,0,0,7V420H28V357a7,7,0,0,1,7-7H63a7,7,0,0,1,7,7v63H224V7A7,7,0,0,0,217,0ZM70,311.5a3.5,3.5,0,0,1-3.5,3.5h-35a3.5,3.5,0,0,1-3.5-3.5v-35a3.5,3.5,0,0,1,3.5-3.5h35a3.5,3.5,0,0,1,3.5,3.5Zm0-77a3.5,3.5,0,0,1-3.5,3.5h-35a3.5,3.5,0,0,1-3.5-3.5v-35a3.5,3.5,0,0,1,3.5-3.5h35a3.5,3.5,0,0,1,3.5,3.5Zm0-77a3.5,3.5,0,0,1-3.5,3.5h-35a3.5,3.5,0,0,1-3.5-3.5v-35a3.5,3.5,0,0,1,3.5-3.5h35a3.5,3.5,0,0,1,3.5,3.5Zm0-77A3.5,3.5,0,0,1,66.5,84h-35A3.5,3.5,0,0,1,28,80.5v-35A3.5,3.5,0,0,1,31.5,42h35A3.5,3.5,0,0,1,70,45.5Zm63,231a3.5,3.5,0,0,1-3.5,3.5h-35a3.5,3.5,0,0,1-3.5-3.5v-35a3.5,3.5,0,0,1,3.5-3.5h35a3.5,3.5,0,0,1,3.5,3.5Zm0-77a3.5,3.5,0,0,1-3.5,3.5h-35a3.5,3.5,0,0,1-3.5-3.5v-35a3.5,3.5,0,0,1,3.5-3.5h35a3.5,3.5,0,0,1,3.5,3.5Zm0-77a3.5,3.5,0,0,1-3.5,3.5h-35a3.5,3.5,0,0,1-3.5-3.5v-35a3.5,3.5,0,0,1,3.5-3.5h35a3.5,3.5,0,0,1,3.5,3.5Zm0-77a3.5,3.5,0,0,1-3.5,3.5h-35A3.5,3.5,0,0,1,91,80.5v-35A3.5,3.5,0,0,1,94.5,42h35a3.5,3.5,0,0,1,3.5,3.5Zm63,231a3.5,3.5,0,0,1-3.5,3.5h-35a3.5,3.5,0,0,1-3.5-3.5v-35a3.5,3.5,0,0,1,3.5-3.5h35a3.5,3.5,0,0,1,3.5,3.5Zm0-77a3.5,3.5,0,0,1-3.5,3.5h-35a3.5,3.5,0,0,1-3.5-3.5v-35a3.5,3.5,0,0,1,3.5-3.5h35a3.5,3.5,0,0,1,3.5,3.5Zm0-77a3.5,3.5,0,0,1-3.5,3.5h-35a3.5,3.5,0,0,1-3.5-3.5v-35a3.5,3.5,0,0,1,3.5-3.5h35a3.5,3.5,0,0,1,3.5,3.5Zm0-77a3.5,3.5,0,0,1-3.5,3.5h-35a3.5,3.5,0,0,1-3.5-3.5v-35a3.5,3.5,0,0,1,3.5-3.5h35a3.5,3.5,0,0,1,3.5,3.5Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
};

const StandingIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      style={{
        height: '30'
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 439.51 420"
        height="30"
      >
        <path
          d="M333,0H123a7,7,0,0,0-7,7V420h28V357a7,7,0,0,1,7-7h28a7,7,0,0,1,7,7v63H340V7A7,7,0,0,0,333,0ZM186,311.5a3.5,3.5,0,0,1-3.5,3.5h-35a3.5,3.5,0,0,1-3.5-3.5v-35a3.5,3.5,0,0,1,3.5-3.5h35a3.5,3.5,0,0,1,3.5,3.5Zm0-77a3.5,3.5,0,0,1-3.5,3.5h-35a3.5,3.5,0,0,1-3.5-3.5v-35a3.5,3.5,0,0,1,3.5-3.5h35a3.5,3.5,0,0,1,3.5,3.5Zm0-77a3.5,3.5,0,0,1-3.5,3.5h-35a3.5,3.5,0,0,1-3.5-3.5v-35a3.5,3.5,0,0,1,3.5-3.5h35a3.5,3.5,0,0,1,3.5,3.5Zm0-77a3.5,3.5,0,0,1-3.5,3.5h-35a3.5,3.5,0,0,1-3.5-3.5v-35a3.5,3.5,0,0,1,3.5-3.5h35a3.5,3.5,0,0,1,3.5,3.5Zm63,231a3.5,3.5,0,0,1-3.5,3.5h-35a3.5,3.5,0,0,1-3.5-3.5v-35a3.5,3.5,0,0,1,3.5-3.5h35a3.5,3.5,0,0,1,3.5,3.5Zm0-77a3.5,3.5,0,0,1-3.5,3.5h-35a3.5,3.5,0,0,1-3.5-3.5v-35a3.5,3.5,0,0,1,3.5-3.5h35a3.5,3.5,0,0,1,3.5,3.5Zm0-77a3.5,3.5,0,0,1-3.5,3.5h-35a3.5,3.5,0,0,1-3.5-3.5v-35a3.5,3.5,0,0,1,3.5-3.5h35a3.5,3.5,0,0,1,3.5,3.5Zm0-77a3.5,3.5,0,0,1-3.5,3.5h-35a3.5,3.5,0,0,1-3.5-3.5v-35a3.5,3.5,0,0,1,3.5-3.5h35a3.5,3.5,0,0,1,3.5,3.5Zm63,231a3.5,3.5,0,0,1-3.5,3.5h-35a3.5,3.5,0,0,1-3.5-3.5v-35a3.5,3.5,0,0,1,3.5-3.5h35a3.5,3.5,0,0,1,3.5,3.5Zm0-77a3.5,3.5,0,0,1-3.5,3.5h-35a3.5,3.5,0,0,1-3.5-3.5v-35a3.5,3.5,0,0,1,3.5-3.5h35a3.5,3.5,0,0,1,3.5,3.5Zm0-77a3.5,3.5,0,0,1-3.5,3.5h-35a3.5,3.5,0,0,1-3.5-3.5v-35a3.5,3.5,0,0,1,3.5-3.5h35a3.5,3.5,0,0,1,3.5,3.5Zm0-77a3.5,3.5,0,0,1-3.5,3.5h-35a3.5,3.5,0,0,1-3.5-3.5v-35a3.5,3.5,0,0,1,3.5-3.5h35a3.5,3.5,0,0,1,3.5,3.5Z"
          fill="currentColor"
        />
        <path
          d="M49.67,88.5,55,103a1.38,1.38,0,0,0,2.59,0L62.94,88.5A42.65,42.65,0,0,1,88.21,63.24l14.47-5.34a1.39,1.39,0,0,0,0-2.6L88.21,50A42.64,42.64,0,0,1,62.94,24.7L57.6,10.24a1.38,1.38,0,0,0-2.59,0L49.67,24.7A42.64,42.64,0,0,1,24.4,50L9.94,55.3a1.38,1.38,0,0,0,0,2.6L24.4,63.24A42.65,42.65,0,0,1,49.67,88.5Z"
          fill="currentColor"
        />
        <path
          d="M54.44,143.09,46,140A24.8,24.8,0,0,1,31.34,125.3l-3.1-8.41a.81.81,0,0,0-.76-.53.8.8,0,0,0-.75.53l-3.1,8.41A24.8,24.8,0,0,1,8.94,140l-8.41,3.1a.8.8,0,0,0,0,1.51l8.41,3.1a24.82,24.82,0,0,1,14.69,14.69l3.1,8.41a.8.8,0,0,0,.75.53.81.81,0,0,0,.76-.53l3.1-8.41A24.8,24.8,0,0,1,46,147.7l8.41-3.1a.8.8,0,0,0,0-1.51Z"
          fill="currentColor"
        />
        <path
          d="M438.74,88.16,426.4,83.61a36.37,36.37,0,0,1-21.54-21.53l-4.55-12.34a1.18,1.18,0,0,0-2.21,0l-4.55,12.33A36.34,36.34,0,0,1,372,83.61l-12.33,4.55a1.19,1.19,0,0,0,0,2.22L372,94.93a36.34,36.34,0,0,1,21.54,21.54l4.55,12.33a1.18,1.18,0,0,0,2.21,0l4.55-12.34A36.4,36.4,0,0,1,426.4,94.93l12.34-4.55a1.19,1.19,0,0,0,0-2.22Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
};

const AtypicalIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      style={{
        height: '30'
      }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 420 420" height="30">
        <path
          d="M389.87,395.39l-12.3-24.61h-106V420H420V395.39Z"
          fill="currentColor"
        />
        <path
          d="M266.82,149.3,223.75,63.16l26-52.19-22-11L210,35.55,192.31,0l-22,11,26,52.19L153.18,149.3Z"
          fill="currentColor"
        />
        <path
          d="M185.39,200.94,210,237.86l24.61-36.92,24.61,36.92,29.64-44.48-9.73-19.47H140.87l-9.73,19.48,29.64,44.47Z"
          fill="currentColor"
        />
        <path d="M30.13,395.39H0V420H148.48V370.78h-106Z" fill="currentColor" />
        <path
          d="M210,321.56a37,37,0,0,0-36.91,36.92V420h73.82V358.48A37,37,0,0,0,210,321.56Z"
          fill="currentColor"
        />
        <path
          d="M301.54,218.74l-42.32,63.48-24.61-36.91L210,282.22l-24.61-36.91-24.61,36.91-42.32-63.48L54.74,346.17h95a61.52,61.52,0,0,1,120.56,0h95Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
};

const DilapidatedIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      style={{
        height: '30'
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 231.15 428.4"
        height="30"
      >
        <path
          d="M180.08,14,155.35,0H7A7,7,0,0,0,0,7V420H28V357a7,7,0,0,1,7-7H63a7,7,0,0,1,7,7v63H224V31.57ZM70,311.5a3.5,3.5,0,0,1-3.5,3.5h-35a3.5,3.5,0,0,1-3.5-3.5v-35a3.5,3.5,0,0,1,3.5-3.5h35a3.5,3.5,0,0,1,3.5,3.5Zm0-77a3.5,3.5,0,0,1-3.5,3.5h-35a3.5,3.5,0,0,1-3.5-3.5v-35a3.5,3.5,0,0,1,3.5-3.5h35a3.5,3.5,0,0,1,3.5,3.5Zm0-77a3.5,3.5,0,0,1-3.5,3.5h-35a3.5,3.5,0,0,1-3.5-3.5v-35a3.5,3.5,0,0,1,3.5-3.5h35a3.5,3.5,0,0,1,3.5,3.5Zm0-77A3.5,3.5,0,0,1,66.5,84h-35A3.5,3.5,0,0,1,28,80.5v-35A3.5,3.5,0,0,1,31.5,42h35A3.5,3.5,0,0,1,70,45.5Zm63,231a3.5,3.5,0,0,1-3.5,3.5h-35a3.5,3.5,0,0,1-3.5-3.5v-35a3.5,3.5,0,0,1,3.5-3.5h35a3.5,3.5,0,0,1,3.5,3.5Zm0-77a3.5,3.5,0,0,1-3.5,3.5h-35a3.5,3.5,0,0,1-3.5-3.5v-35a3.5,3.5,0,0,1,3.5-3.5h35a3.5,3.5,0,0,1,3.5,3.5Zm0-77a3.5,3.5,0,0,1-3.5,3.5h-35a3.5,3.5,0,0,1-3.5-3.5v-35a3.5,3.5,0,0,1,3.5-3.5h35a3.5,3.5,0,0,1,3.5,3.5Zm0-77a3.5,3.5,0,0,1-3.5,3.5h-35A3.5,3.5,0,0,1,91,80.5v-35A3.5,3.5,0,0,1,94.5,42h35a3.5,3.5,0,0,1,3.5,3.5Zm63,231a3.5,3.5,0,0,1-3.5,3.5h-35a3.5,3.5,0,0,1-3.5-3.5v-35a3.5,3.5,0,0,1,3.5-3.5h35a3.5,3.5,0,0,1,3.5,3.5Zm0-77a3.5,3.5,0,0,1-3.5,3.5h-35a3.5,3.5,0,0,1-3.5-3.5v-35a3.5,3.5,0,0,1,3.5-3.5h35a3.5,3.5,0,0,1,3.5,3.5Zm0-77a3.5,3.5,0,0,1-3.5,3.5h-35a3.5,3.5,0,0,1-3.5-3.5v-35a3.5,3.5,0,0,1,3.5-3.5h35a3.5,3.5,0,0,1,3.5,3.5Zm0-77a3.5,3.5,0,0,1-3.5,3.5h-35a3.5,3.5,0,0,1-3.5-3.5v-35a3.5,3.5,0,0,1,3.5-3.5h35a3.5,3.5,0,0,1,3.5,3.5Z"
          fill="currentColor"
        />
        <polyline
          points="61.75 357.23 123.66 372.12 166.76 360.37 230.24 380.74"
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: 10,
            strokeWidth: 6
          }}
        />
        <polyline
          points="166.76 360.37 155.79 387.8 176.95 426.98"
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: 10,
            strokeWidth: 6
          }}
        />
        <polyline
          points="123.66 372.12 136.98 339.21 104.85 307.87"
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: 10,
            strokeWidth: 6
          }}
        />
        <line
          x1="209.86"
          y1="424.63"
          x2="198.89"
          y2="370.56"
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: 10,
            strokeWidth: 6
          }}
        />
        <line
          x1="178.52"
          y1="3.03"
          x2="176.16"
          y2="51.62"
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: 10,
            strokeWidth: 6
          }}
        />
        <line
          x1="228.67"
          y1="26.54"
          x2="176.95"
          y2="50.83"
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: 10,
            strokeWidth: 6
          }}
        />
        <polyline
          points="49.22 115.87 21.79 148 13.17 110.39 76.64 163.68"
          style={{
            fill: 'none',
            stroke: 'currentColor',
            strokeMiterlimit: 10,
            strokeWidth: 6
          }}
        />
        <polyline
          points="140.9 133.9 86.05 146.44 83.69 106.47 108.77 170.73 130.71 169.94 110.34 111.17"
          style={{
            fill: 'none',
            stroke: 'currentColor',
            strokeMiterlimit: 10,
            strokeWidth: 6
          }}
        />
        <polyline
          points="83.69 271.03 142.47 325.11 139.33 267.9 80.56 321.97 79.78 289.84 151.09 262.41"
          style={{
            fill: 'none',
            stroke: 'currentColor',
            strokeMiterlimit: 10,
            strokeWidth: 6
          }}
        />
        <polyline
          points="27.27 31.24 75.08 90.8 79.78 31.24 24.92 88.45"
          style={{
            fill: 'none',
            stroke: 'currentColor',
            strokeMiterlimit: 10,
            strokeWidth: 6
          }}
        />
        <polyline
          points="144.03 202.07 203.59 225.58 204.38 198.94 165.98 244.39"
          style={{
            fill: 'none',
            stroke: 'currentColor',
            strokeMiterlimit: 10,
            strokeWidth: 6
          }}
        />
      </svg>
    </span>
  );
};

const FurnishedIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      style={{
        height: '30'
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 500 352.06"
        height="30"
      >
        <path
          d="M156,211.82a25.64,25.64,0,0,1,25.61-25.6h75.61a25.64,25.64,0,0,1,25.6,25.6V226.5h31V211.82a25.64,25.64,0,0,1,25.61-25.6H415a25.63,25.63,0,0,1,25.6,25.6V226.5h22.76V124.19a14.92,14.92,0,0,0-14.9-14.9H148.1a14.92,14.92,0,0,0-14.91,14.9V226.5H156Z"
          fill="currentColor"
        />
        <path
          d="M111.05,245.81v20.27H486.42V245.81a9.68,9.68,0,0,0-9.67-9.67h-356A9.68,9.68,0,0,0,111.05,245.81Z"
          fill="currentColor"
        />
        <path
          d="M123.55,215.51V175.24H7.73A7.74,7.74,0,0,0,0,183v32.54ZM72.13,200.19H51.91a4.82,4.82,0,0,1,0-9.64H72.13a4.82,4.82,0,1,1,0,9.64Z"
          fill="currentColor"
        />
        <path
          d="M257.17,195.86H181.56a16,16,0,0,0-16,16V226.5H273.14V211.82A16,16,0,0,0,257.17,195.86Z"
          fill="currentColor"
        />
        <path
          d="M101.41,245.81a19.34,19.34,0,0,1,19.31-19.31h2.83v-1.35H0v66.42a7.73,7.73,0,0,0,7.73,7.72h80.1V279.75a13.66,13.66,0,0,1,13.58-13.67Z"
          fill="currentColor"
        />
        <path
          d="M496,275.72H101.44a4,4,0,0,0-4,4v68.34a4,4,0,0,0,4,4H133a3.93,3.93,0,0,0,4-4V322.71a13.66,13.66,0,0,1,13.68-13.61H446.8a13.66,13.66,0,0,1,13.68,13.61v25.38a3.93,3.93,0,0,0,4,4H496a4,4,0,0,0,4-4V279.75A4.05,4.05,0,0,0,496,275.72Z"
          fill="currentColor"
        />
        <path
          d="M415,195.86H339.42a16,16,0,0,0-16,16V226.5H431V211.82A16,16,0,0,0,415,195.86Z"
          fill="currentColor"
        />
        <path
          d="M11.63,81.43H52.39v55.89H42.08a14.38,14.38,0,0,0-14.36,14.26v14.07H86.6V151.58a14.29,14.29,0,0,0-14.26-14.26H62V81.43h40.76a4.73,4.73,0,0,0,3.86-2,4.46,4.46,0,0,0,.67-4.24L84.67,3.37A4.85,4.85,0,0,0,80.05,0H34.28a4.73,4.73,0,0,0-4.53,3.37L7,75.17a4.47,4.47,0,0,0,.78,4.24A4.7,4.7,0,0,0,11.63,81.43Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
};

const UnfurnishedIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      style={{
        height: '30'
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 500 352.06"
        height="30"
      >
        <path
          d="M156,211.82a25.64,25.64,0,0,1,25.61-25.6h75.61a25.64,25.64,0,0,1,25.6,25.6V226.5h31V211.82a25.64,25.64,0,0,1,25.61-25.6H415a25.63,25.63,0,0,1,25.6,25.6V226.5h22.76V124.19a14.92,14.92,0,0,0-14.9-14.9H148.1a14.92,14.92,0,0,0-14.91,14.9V226.5H156Z"
          fill="currentColor"
        />
        <path
          d="M111.05,245.81v20.27H486.42V245.81a9.68,9.68,0,0,0-9.67-9.67h-356A9.68,9.68,0,0,0,111.05,245.81Z"
          fill="currentColor"
        />
        <path
          d="M123.55,215.51V175.24H7.73A7.74,7.74,0,0,0,0,183v32.54ZM72.13,200.19H51.91a4.82,4.82,0,0,1,0-9.64H72.13a4.82,4.82,0,1,1,0,9.64Z"
          fill="currentColor"
        />
        <path
          d="M257.17,195.86H181.56a16,16,0,0,0-16,16V226.5H273.14V211.82A16,16,0,0,0,257.17,195.86Z"
          fill="currentColor"
        />
        <path
          d="M101.41,245.81a19.34,19.34,0,0,1,19.31-19.31h2.83v-1.35H0v66.42a7.73,7.73,0,0,0,7.73,7.72h80.1V279.75a13.66,13.66,0,0,1,13.58-13.67Z"
          fill="currentColor"
        />
        <path
          d="M496,275.72H101.44a4,4,0,0,0-4,4v68.34a4,4,0,0,0,4,4H133a3.93,3.93,0,0,0,4-4V322.71a13.66,13.66,0,0,1,13.68-13.61H446.8a13.66,13.66,0,0,1,13.68,13.61v25.38a3.93,3.93,0,0,0,4,4H496a4,4,0,0,0,4-4V279.75A4.05,4.05,0,0,0,496,275.72Z"
          fill="currentColor"
        />
        <path
          d="M415,195.86H339.42a16,16,0,0,0-16,16V226.5H431V211.82A16,16,0,0,0,415,195.86Z"
          fill="currentColor"
        />
        <path
          d="M11.63,81.43H52.39v55.89H42.08a14.38,14.38,0,0,0-14.36,14.26v14.07H86.6V151.58a14.29,14.29,0,0,0-14.26-14.26H62V81.43h40.76a4.73,4.73,0,0,0,3.86-2,4.46,4.46,0,0,0,.67-4.24L84.67,3.37A4.85,4.85,0,0,0,80.05,0H34.28a4.73,4.73,0,0,0-4.53,3.37L7,75.17a4.47,4.47,0,0,0,.78,4.24A4.7,4.7,0,0,0,11.63,81.43Z"
          fill="currentColor"
        />
        <polygon
          points="403.8 61.87 364.16 22.23 250 136.38 135.84 22.23 96.2 61.87 210.36 176.03 96.2 290.19 135.84 329.83 250 215.67 364.16 329.83 403.8 290.19 289.64 176.03 403.8 61.87"
          style={{
            fill: '#fff',
            stroke: 'currentColor',
            strokeMiterlimit: 10,
            strokeWidth: '15.8984258974378px'
          }}
        />
      </svg>
    </span>
  );
};

const OtherIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      style={{
        height: '30'
      }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 420 420" height="30">
        <path
          d="M210,0C94,0,0,94,0,210S94,420,210,420s210-94,210-210S326,0,210,0Zm9.47,299.6H186.86V268h32.61Zm25.34-99.81a67,67,0,0,1-25.34,25.59v27.34H186.86V214.83a97.83,97.83,0,0,0,12.25-9.91A103.68,103.68,0,0,0,210,192.76a57.17,57.17,0,0,0,8.06-14.5,43.84,43.84,0,0,0,3-15.57q0-6.75-3.18-10.16t-9.13-3.42a9.1,9.1,0,0,0-8.25,4.44,20.51,20.51,0,0,0-2.78,11.09,41,41,0,0,0,1.85,12.11l-30.66,5.86a81.24,81.24,0,0,1-2.84-20.51q0-18.75,10.65-30.23t32-11.47q21.59,0,33.4,11.47T254,164.64A70.38,70.38,0,0,1,244.81,199.79Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
};

const HouseIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      style={{
        height: '30'
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 492.57 420"
        height="30"
      >
        <path
          d="M246.28,84.78,70.61,240a4.76,4.76,0,0,1-.15,1,5,5,0,0,0-.16,1V399a20.86,20.86,0,0,0,5.81,14.73A18.23,18.23,0,0,0,89.86,420H207.17V294.29H285.4V420H402.71a18.19,18.19,0,0,0,13.75-6.23A20.86,20.86,0,0,0,422.27,399V241.91a4.87,4.87,0,0,0-.31-2Z"
          fill="currentColor"
        />
        <path
          d="M489.17,204.6,422.26,145V11.46a10.59,10.59,0,0,0-2.75-7.53,9.16,9.16,0,0,0-7-2.94H353.83a9.2,9.2,0,0,0-7,2.94,10.63,10.63,0,0,0-2.75,7.53V75.29L269.51,8.51a35.93,35.93,0,0,0-46.44,0L3.39,204.6a9.77,9.77,0,0,0-3.36,7,11.17,11.17,0,0,0,2.14,7.7l18.94,24.23a10.26,10.26,0,0,0,6.42,3.6,10.85,10.85,0,0,0,7.34-2.29L246.28,56,457.71,244.87a9,9,0,0,0,6.41,2.28H465a10.24,10.24,0,0,0,6.42-3.6l18.94-24.22a11.13,11.13,0,0,0,2.13-7.7A9.77,9.77,0,0,0,489.17,204.6Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
};

const ApartmentIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      style={{
        height: '30'
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 111.98 98.81"
        height="30"
      >
        <path
          d="M51.05,0H1.65A1.65,1.65,0,0,0,0,1.65V98.81H6.59V84a1.64,1.64,0,0,1,1.64-1.65h6.59A1.65,1.65,0,0,1,16.47,84V98.81H52.7V1.65A1.65,1.65,0,0,0,51.05,0ZM16.47,73.28a.83.83,0,0,1-.83.83H7.41a.83.83,0,0,1-.82-.83V65.05a.82.82,0,0,1,.82-.82h8.23a.83.83,0,0,1,.83.82Zm0-18.11a.83.83,0,0,1-.83.82H7.41a.82.82,0,0,1-.82-.82V46.93a.82.82,0,0,1,.82-.82h8.23a.83.83,0,0,1,.83.82Zm0-18.12a.83.83,0,0,1-.83.83H7.41a.83.83,0,0,1-.82-.83V28.82A.82.82,0,0,1,7.41,28h8.23a.82.82,0,0,1,.83.82Zm0-18.11a.83.83,0,0,1-.83.82H7.41a.82.82,0,0,1-.82-.82V10.7a.82.82,0,0,1,.82-.82h8.23a.83.83,0,0,1,.83.82ZM31.29,73.28a.83.83,0,0,1-.82.83H22.23a.83.83,0,0,1-.82-.83V65.05a.82.82,0,0,1,.82-.82h8.24a.82.82,0,0,1,.82.82Zm0-18.11a.82.82,0,0,1-.82.82H22.23a.82.82,0,0,1-.82-.82V46.93a.82.82,0,0,1,.82-.82h8.24a.82.82,0,0,1,.82.82Zm0-18.12a.83.83,0,0,1-.82.83H22.23a.83.83,0,0,1-.82-.83V28.82a.82.82,0,0,1,.82-.82h8.24a.82.82,0,0,1,.82.82Zm0-18.11a.82.82,0,0,1-.82.82H22.23a.82.82,0,0,1-.82-.82V10.7a.82.82,0,0,1,.82-.82h8.24a.82.82,0,0,1,.82.82ZM46.11,73.28a.83.83,0,0,1-.82.83H37.05a.83.83,0,0,1-.82-.83V65.05a.82.82,0,0,1,.82-.82h8.24a.82.82,0,0,1,.82.82Zm0-18.11a.82.82,0,0,1-.82.82H37.05a.82.82,0,0,1-.82-.82V46.93a.82.82,0,0,1,.82-.82h8.24a.82.82,0,0,1,.82.82Zm0-18.12a.83.83,0,0,1-.82.83H37.05a.83.83,0,0,1-.82-.83V28.82a.82.82,0,0,1,.82-.82h8.24a.82.82,0,0,1,.82.82Zm0-18.11a.82.82,0,0,1-.82.82H37.05a.82.82,0,0,1-.82-.82V10.7a.82.82,0,0,1,.82-.82h8.24a.82.82,0,0,1,.82.82Zm64.67,28.48-49.4-13.9a1.65,1.65,0,0,0-2.09,1.59v63.7h6.58V85.63A1.65,1.65,0,0,1,67.52,84h6.59a1.64,1.64,0,0,1,1.64,1.64V98.81H112V49A1.65,1.65,0,0,0,110.78,47.42Zm-35,29.16a.82.82,0,0,1-.82.82H66.7a.83.83,0,0,1-.83-.82V68.34a.83.83,0,0,1,.83-.82h8.23a.82.82,0,0,1,.82.82Zm0-18.12a.82.82,0,0,1-.82.83H66.7a.83.83,0,0,1-.83-.83V50.23a.83.83,0,0,1,.83-.83h8.23a.82.82,0,0,1,.82.83ZM90.58,76.58a.83.83,0,0,1-.83.82H81.52a.83.83,0,0,1-.83-.82V68.34a.83.83,0,0,1,.83-.82h8.23a.83.83,0,0,1,.83.82Zm0-18.12a.83.83,0,0,1-.83.83H81.52a.83.83,0,0,1-.83-.83V50.23a.83.83,0,0,1,.83-.83h8.23a.83.83,0,0,1,.83.83ZM105.4,76.58a.83.83,0,0,1-.83.82H96.34a.82.82,0,0,1-.82-.82V68.34a.82.82,0,0,1,.82-.82h8.23a.83.83,0,0,1,.83.82Zm0-18.12a.83.83,0,0,1-.83.83H96.34a.82.82,0,0,1-.82-.83V50.23a.82.82,0,0,1,.82-.83h8.23a.83.83,0,0,1,.83.83Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
};

const OfficeIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      style={{
        height: '30'
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 121.47 98.69"
        height="30"
      >
        <path
          d="M119.57,41.76H96.8v-7.6h13.28a1.9,1.9,0,0,0,1.9-1.89V1.9a1.9,1.9,0,0,0-1.9-1.9h-38a1.9,1.9,0,0,0-1.9,1.9V32.27a1.9,1.9,0,0,0,1.9,1.89H85.41v7.6h-19V32.27a5.7,5.7,0,0,0-5.69-5.7H38a5.7,5.7,0,0,0-5.69,5.7v9.49h-3.8V26.57a1.9,1.9,0,0,0-1.9-1.9h-19a1.9,1.9,0,0,0-1.9,1.9V41.76H1.9A1.9,1.9,0,0,0,0,43.65v9.49A1.9,1.9,0,0,0,1.9,55H16.52L5.76,96.32l3.67,1,9.38-36L26.62,97.2l3.7-.81L21.33,55H32.27v3.8A5.69,5.69,0,0,0,38,64.53h9.49v1.9H34.16a1.9,1.9,0,0,0-1.89,1.9V74a1.9,1.9,0,0,0,1.89,1.9H47.45V89.2H36.06a1.9,1.9,0,0,0-1.9,1.9v7.59H38V93H60.74v5.69h3.79V91.1a1.9,1.9,0,0,0-1.9-1.9H51.25V75.92H64.53a1.9,1.9,0,0,0,1.9-1.9V68.33a1.9,1.9,0,0,0-1.9-1.9H51.25v-1.9h9.49a5.69,5.69,0,0,0,5.69-5.69V55H96L85.23,96.32l3.68,1,9.38-36,7.8,35.89,3.71-.81-9-41.35h18.76a1.9,1.9,0,0,0,1.9-1.9V43.65a1.9,1.9,0,0,0-1.9-1.89Zm-11.39-38v19H74V3.8ZM24.67,28.47v3.8H9.49v-3.8ZM3.8,51.25v-5.7H32.27v5.7Zm113.87,0H66.43v-5.7h51.24Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
};

const PremisesIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      style={{
        height: '30'
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 328.16 420"
        height="30"
      >
        <path
          d="M0,8.38V411.62A8.38,8.38,0,0,0,8.38,420H24.1a8.38,8.38,0,0,0,8.38-8.38V312.45a8.39,8.39,0,0,1,8.38-8.39h46a8.39,8.39,0,0,1,8.38,8.39v99.17a8.38,8.38,0,0,0,8.38,8.38h19.08a8.38,8.38,0,0,0,8.38-8.38V197.52a8.38,8.38,0,0,1,8.38-8.38h143.4a8.38,8.38,0,0,1,8.38,8.38v214.1a8.38,8.38,0,0,0,8.38,8.38h20.2a8.38,8.38,0,0,0,8.38-8.38V8.38A8.38,8.38,0,0,0,319.78,0H8.38A8.38,8.38,0,0,0,0,8.38ZM69.3,136.25H43.1a8.38,8.38,0,0,1-8.38-8.38V107.18a8.39,8.39,0,0,1,8.38-8.39H69.3a8.39,8.39,0,0,1,8.39,8.39v20.69A8.38,8.38,0,0,1,69.3,136.25ZM69.3,89H43.1a8.38,8.38,0,0,1-8.38-8.38V59.9a8.38,8.38,0,0,1,8.38-8.38H69.3a8.38,8.38,0,0,1,8.39,8.38V80.6A8.38,8.38,0,0,1,69.3,89Zm54.23,47.27H97.33a8.39,8.39,0,0,1-8.39-8.38V107.18a8.39,8.39,0,0,1,8.39-8.39h26.2a8.39,8.39,0,0,1,8.38,8.39v20.69A8.38,8.38,0,0,1,123.53,136.25Zm0-47.27H97.33a8.39,8.39,0,0,1-8.39-8.38V59.9a8.39,8.39,0,0,1,8.39-8.38h26.2a8.38,8.38,0,0,1,8.38,8.38V80.6A8.38,8.38,0,0,1,123.53,89Zm54.22,47.27h-26.2a8.38,8.38,0,0,1-8.38-8.38V107.18a8.39,8.39,0,0,1,8.38-8.39h26.2a8.39,8.39,0,0,1,8.39,8.39v20.69A8.39,8.39,0,0,1,177.75,136.25Zm0-47.27h-26.2a8.38,8.38,0,0,1-8.38-8.38V59.9a8.38,8.38,0,0,1,8.38-8.38h26.2a8.39,8.39,0,0,1,8.39,8.38V80.6A8.39,8.39,0,0,1,177.75,89Zm54.42,47.27H206a8.39,8.39,0,0,1-8.39-8.38V107.18A8.39,8.39,0,0,1,206,98.79h26.2a8.39,8.39,0,0,1,8.38,8.39v20.69A8.38,8.38,0,0,1,232.17,136.25Zm0-47.27H206a8.39,8.39,0,0,1-8.39-8.38V59.9A8.39,8.39,0,0,1,206,51.52h26.2a8.38,8.38,0,0,1,8.38,8.38V80.6A8.38,8.38,0,0,1,232.17,89Zm54.22,47.27h-26.2a8.38,8.38,0,0,1-8.38-8.38V107.18a8.39,8.39,0,0,1,8.38-8.39h26.2a8.39,8.39,0,0,1,8.39,8.39v20.69A8.39,8.39,0,0,1,286.39,136.25Zm0-47.27h-26.2a8.38,8.38,0,0,1-8.38-8.38V59.9a8.38,8.38,0,0,1,8.38-8.38h26.2a8.39,8.39,0,0,1,8.39,8.38V80.6A8.39,8.39,0,0,1,286.39,89Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
};

const HangarIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      style={{
        height: '30'
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 114 88.17"
        height="30"
      >
        <path d="M38.06,0V0S38.08,0,38.06,0Z" fill="currentColor" />
        <path d="M114,0V0S114,0,114,0Z" fill="currentColor" />
        <path d="M75.92,0V0S75.94,0,75.92,0Z" fill="currentColor" />
        <path
          d="M75.93,22.81h0V1.69A.88.88,0,0,0,74.57.94C68.1,5,40.64,21.18,38.06,22.7v-21A.88.88,0,0,0,36.71.94C29.91,5.23,0,22.81,0,22.81H0V87.28a.89.89,0,0,0,.89.89H62.8a.89.89,0,0,0,.89-.89V47.61a.88.88,0,0,1,.88-.89H98.11a.89.89,0,0,1,.89.89V87.28a.89.89,0,0,0,.89.89h13.17a.88.88,0,0,0,.88-.89V22.81h0V1.69a.89.89,0,0,0-1.36-.75C105.83,5.24,75.93,22.81,75.93,22.81Zm-51.57,49H15.07a.89.89,0,0,1-.89-.89V61.58a.89.89,0,0,1,.89-.89h9.29a.89.89,0,0,1,.89.89v9.29A.89.89,0,0,1,24.36,71.76Zm0-14H15.07a.88.88,0,0,1-.89-.88v-9.3a.89.89,0,0,1,.89-.89h9.29a.89.89,0,0,1,.89.89v9.3A.88.88,0,0,1,24.36,57.79Zm14,14H29a.89.89,0,0,1-.89-.89V61.58a.89.89,0,0,1,.89-.89h9.29a.89.89,0,0,1,.89.89v9.29A.89.89,0,0,1,38.33,71.76Zm0-14H29a.88.88,0,0,1-.89-.88v-9.3a.89.89,0,0,1,.89-.89h9.29a.89.89,0,0,1,.89.89v9.3A.88.88,0,0,1,38.33,57.79Zm14,14H43a.88.88,0,0,1-.88-.89V61.58a.88.88,0,0,1,.88-.89h9.3a.88.88,0,0,1,.88.89v9.29A.88.88,0,0,1,52.3,71.76Zm0-14H43a.87.87,0,0,1-.88-.88v-9.3a.88.88,0,0,1,.88-.89h9.3a.88.88,0,0,1,.88.89v9.3A.87.87,0,0,1,52.3,57.79Z"
          fill="currentColor"
        />
        <rect
          x="66.4"
          y="49.83"
          width="29.89"
          height="5.87"
          rx="0.89"
          fill="currentColor"
        />
        <rect
          x="66.4"
          y="57.33"
          width="29.89"
          height="5.87"
          rx="0.89"
          fill="currentColor"
        />
        <rect
          x="66.4"
          y="64.83"
          width="29.89"
          height="5.87"
          rx="0.89"
          fill="currentColor"
        />
      </svg>
    </span>
  );
};

const IndustrialIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      style={{
        height: '30'
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 94.01 107.51"
        height="30"
      >
        <path
          d="M64.19,36.54A6.82,6.82,0,0,0,70.64,32,10.35,10.35,0,0,0,81,23.12a11.45,11.45,0,0,0,8-3.38,11.56,11.56,0,1,0-19.74-8.33,10.35,10.35,0,0,0-8.66,12.42,7.29,7.29,0,0,0-1.28,1,6.85,6.85,0,0,0,4.84,11.7Z"
          fill="currentColor"
        />
        <path
          d="M91.52,74.15H71.16v-30a2.5,2.5,0,0,0-2.5-2.5H57.55a2.5,2.5,0,0,0-2.5,2.5v14.4L31.26,44.11a3.23,3.23,0,0,0-1.66-.43,3.34,3.34,0,0,0-1.79.5L1.6,61.62a3.82,3.82,0,0,0-1.6,3V105a2.5,2.5,0,0,0,2.5,2.49h89A2.5,2.5,0,0,0,94,105V76.65A2.5,2.5,0,0,0,91.52,74.15ZM18.15,98.5H7.49V87.84H18.15Zm0-17.77H7.49V70.07H18.15ZM35.86,98.5H25.19V87.84H35.86Zm0-17.77H25.19V70.07H35.86ZM53.56,98.5H42.89V87.84H53.56Zm0-17.77H42.89V70.07H53.56ZM71.26,98.5H60.6V87.84H71.26ZM89,98.5H78.3V87.84H89Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
};

const CommercialIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      style={{
        height: '30'
      }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 420 420" height="30">
        <path
          d="M0,170.62a52.41,52.41,0,0,0,39.37,50.66V393.75H13.13a13.13,13.13,0,1,0,0,26.25H406.87a13.13,13.13,0,1,0,0-26.25H380.62V221.28A52.4,52.4,0,0,0,420,170.62V157.5H0Zm262.5,52.51A52.49,52.49,0,0,0,315,170.62a52.39,52.39,0,0,0,39.38,50.66V393.75H157.5V223.13A52.49,52.49,0,0,0,210,170.62a52.52,52.52,0,0,0,52.5,52.51Zm-118.12-1.85V393.75H65.62V221.28A52.39,52.39,0,0,0,105,170.62a52.39,52.39,0,0,0,39.38,50.66ZM367.5,39.37H52.5L0,144.38H420ZM110.9,68.55l-26.25,52.5a6.65,6.65,0,0,1-5.9,3.64,6.42,6.42,0,0,1-2.92-.69,6.55,6.55,0,0,1-2.93-8.8L99.15,62.7a6.56,6.56,0,0,1,11.75,5.85Zm52.5,0-26.25,52.5a6.64,6.64,0,0,1-5.9,3.64,6.54,6.54,0,0,1-5.84-9.49l26.24-52.5a6.56,6.56,0,1,1,11.75,5.85Zm53.16,49.57a6.57,6.57,0,1,1-13.13,0V65.62a6.57,6.57,0,0,1,13.13,0Zm75.37,5.75a6.61,6.61,0,0,1-3.18.82,6.53,6.53,0,0,1-5.74-3.41L254.3,68.78a6.57,6.57,0,0,1,11.53-6.31L294.54,115a6.59,6.59,0,0,1-2.61,8.9Zm52.24.13a6.21,6.21,0,0,1-2.92.69,6.49,6.49,0,0,1-5.84-3.64L309.15,68.54a6.56,6.56,0,1,1,11.74-5.84l26.26,52.5a6.57,6.57,0,0,1-3,8.8ZM111.56,317V286.75A13,13,0,0,1,105,275.62a13.13,13.13,0,0,1,26.25,0,12.94,12.94,0,0,1-6.56,11.13V317a12.93,12.93,0,0,1,6.56,11.12A13.13,13.13,0,1,1,111.56,317ZM52.5,13.13A13.13,13.13,0,0,1,65.62,0H354.38a13.13,13.13,0,0,1,0,26.25H65.62A13.13,13.13,0,0,1,52.5,13.13ZM230.05,293.39l-9.28-9.28L257.88,247l9.29,9.28Zm0,37.12-9.28-9.28L295,247l9.28,9.28ZM295,284.11l9.28,9.28-37.11,37.12-9.29-9.28Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
};

const CommercialCellIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      style={{
        height: '30'
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 500 339.03"
        height="30"
      >
        <path
          d="M500,36.75V0H0V36.75H12.33V302.28H0V339H500V302.28H487.68V36.75ZM157.11,302.28H62.57V118.65h94.54Zm39.24-181h60.59V234.7H196.35Zm19.53,172.59a14.18,14.18,0,1,1,12.22-12.22A14.19,14.19,0,0,1,215.88,293.84Zm50.42,0a14.19,14.19,0,1,1,12.22-12.22A14.2,14.2,0,0,1,266.3,293.84Zm50.43,0A14.19,14.19,0,1,1,329,281.62,14.2,14.2,0,0,1,316.73,293.84Zm30.46-59.14h-60.6V121.25h60.6Zm20,59.14a14.18,14.18,0,1,1,12.22-12.22A14.19,14.19,0,0,1,367.15,293.84Zm50.42,0a14.19,14.19,0,1,1,12.22-12.22A14.19,14.19,0,0,1,417.57,293.84Zm19.86-59.14H376.84V121.25h60.59Z"
          fill="currentColor"
        />
        <path
          d="M107.79,65.17v-16q0-17.13,14-17.13a16,16,0,0,1,5.25.79,10.62,10.62,0,0,1,6.42,5.62,16.89,16.89,0,0,1,1.45,4.44,28.42,28.42,0,0,1,.45,5.26V52.3h-9.62V47.84c0-.87,0-1.63-.05-2.27a18.48,18.48,0,0,0-.28-2.17,7.68,7.68,0,0,0-.62-2,3.58,3.58,0,0,0-1.16-1.3,3.1,3.1,0,0,0-1.84-.54q-4.25,0-4.24,7.15V67.58q0,7.13,4.24,7.12a3.17,3.17,0,0,0,2.13-.73,4,4,0,0,0,1.23-2,15.81,15.81,0,0,0,.51-2.61,28,28,0,0,0,.13-2.91v-5h9.57v4.08a34.4,34.4,0,0,1-.46,5.11,19.94,19.94,0,0,1-1.37,4.54,12.31,12.31,0,0,1-2.46,3.71,10.8,10.8,0,0,1-3.85,2.45,14.78,14.78,0,0,1-5.43.93,16,16,0,0,1-5.57-.9,11.38,11.38,0,0,1-4-2.42,12.24,12.24,0,0,1-2.59-3.73,18.67,18.67,0,0,1-1.44-4.66A31.81,31.81,0,0,1,107.79,65.17Z"
          fill="#fff"
        />
        <path
          d="M144.82,65.41V49.16Q144.82,32,159,32T173.1,49.16v16a30.76,30.76,0,0,1-.43,5.35,18.06,18.06,0,0,1-1.46,4.66,12.68,12.68,0,0,1-2.63,3.75,11.32,11.32,0,0,1-4,2.43,18,18,0,0,1-11.15,0,11.42,11.42,0,0,1-4-2.36,12.22,12.22,0,0,1-2.62-3.65,17.87,17.87,0,0,1-1.47-4.61A29.55,29.55,0,0,1,144.82,65.41Zm18.51,2.2V46.72q0-7.15-4.38-7.15a3.7,3.7,0,0,0-2.23.66,3.77,3.77,0,0,0-1.34,1.8,11.34,11.34,0,0,0-.61,2.26,16.55,16.55,0,0,0-.17,2.43V67.61c0,4.74,1.45,7.12,4.35,7.12S163.33,72.35,163.33,67.61Z"
          fill="#fff"
        />
        <path
          d="M183.73,81.31V33h11.71l5.16,32.22L206.16,33h11.3V81.31h-7.2l-.21-34q-.81,5.23-2.82,17t-2.82,17h-7.3l-5.94-34.22L191,81.31Z"
          fill="#fff"
        />
        <path
          d="M228.71,81.31V33h11.71l5.15,32.22L251.13,33h11.31V81.31h-7.2l-.21-34q-.81,5.23-2.82,17t-2.82,17h-7.31l-5.93-34.22-.22,34.22Z"
          fill="#fff"
        />
        <path
          d="M273.69,81.31V33h20.16v6.71H283.46V52.84h7.36v6.87h-7.36V74.59h10.39v6.72Z"
          fill="#fff"
        />
        <path
          d="M302.85,81.31V33h10.63a26.44,26.44,0,0,1,6.38.68,14.22,14.22,0,0,1,4.82,2.15,9.07,9.07,0,0,1,3.14,4,14.85,14.85,0,0,1,1.08,6c0,1,0,1.89-.11,2.68a17.07,17.07,0,0,1-.5,2.7,10.71,10.71,0,0,1-1.06,2.69,9.64,9.64,0,0,1-1.93,2.29,11.2,11.2,0,0,1-3,1.88q4.35,13.8,7.57,23.37H319.77L314.23,59h-1.61V81.31Zm9.77-28.23h2.79a2.74,2.74,0,0,0,1.94-.75,4.47,4.47,0,0,0,1.17-1.91A15,15,0,0,0,319,48.3a13.19,13.19,0,0,0,.14-1.83,13.61,13.61,0,0,0-.12-1.77,14.59,14.59,0,0,0-.43-2,3.92,3.92,0,0,0-1-1.82,2.32,2.32,0,0,0-1.73-.71h-3.25Z"
          fill="#fff"
        />
        <path
          d="M337.86,65.17v-16q0-17.13,14-17.13a16,16,0,0,1,5.25.79,10.69,10.69,0,0,1,6.42,5.62A17.26,17.26,0,0,1,365,42.88a29.35,29.35,0,0,1,.44,5.26V52.3h-9.61V47.84c0-.87,0-1.63-.06-2.27a16.57,16.57,0,0,0-.28-2.17,7.31,7.31,0,0,0-.62-2,3.56,3.56,0,0,0-1.15-1.3,3.12,3.12,0,0,0-1.84-.54q-4.25,0-4.24,7.15V67.58q0,7.13,4.24,7.12A3.14,3.14,0,0,0,354,74a4,4,0,0,0,1.24-2,15.81,15.81,0,0,0,.51-2.61,28,28,0,0,0,.13-2.91v-5h9.56v4.08a33.11,33.11,0,0,1-.46,5.11,19,19,0,0,1-1.37,4.54,12.29,12.29,0,0,1-2.45,3.71,10.84,10.84,0,0,1-3.86,2.45,14.69,14.69,0,0,1-5.42.93,16,16,0,0,1-5.57-.9,11.43,11.43,0,0,1-4-2.42,12.41,12.41,0,0,1-2.59-3.73,18.25,18.25,0,0,1-1.43-4.66A31.81,31.81,0,0,1,337.86,65.17Z"
          fill="#fff"
        />
        <path
          d="M375.51,81.31V33h20.16v6.71H385.28V52.84h7.36v6.87h-7.36V74.59h10.39v6.72Z"
          fill="#fff"
        />
      </svg>
    </span>
  );
};

const ShoppingArcadeIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      style={{
        height: '30'
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 455.23 420"
        height="30"
      >
        <path
          d="M89.53,30.59V6.91a6.91,6.91,0,1,0-13.81,0V30.59"
          fill="currentColor"
        />
        <path
          d="M240.08,76.42V57.08a6.91,6.91,0,0,0-13.82,0V76.42"
          fill="currentColor"
        />
        <path
          d="M0,75.42V387.64H40.54V322.4a6.91,6.91,0,0,1,6.91-6.91h34.7c.16,0,.31,0,.48,0s.32,0,.47,0h36.82a6.91,6.91,0,0,1,6.91,6.91v65.24h40.54V75.42ZM137.54,267.91H29.87a6.91,6.91,0,1,1,0-13.82H137.53a6.91,6.91,0,0,1,0,13.82Zm0-49.53H29.87a6.91,6.91,0,1,1,0-13.81H137.53a6.91,6.91,0,1,1,0,13.81Zm0-49.52H29.87a6.91,6.91,0,1,1,0-13.82H137.53a6.91,6.91,0,0,1,0,13.82Zm0-49.53H29.87a6.91,6.91,0,0,1,0-13.82H137.53a6.91,6.91,0,1,1,0,13.82Z"
          fill="currentColor"
        />
        <path d="M210.81,83.51H255v22.17H210.81Z" fill="currentColor" />
        <path d="M54.35,329.31H75.72v58.33H54.35Z" fill="currentColor" />
        <path
          d="M430.13,258.8s0-.08,0-.13a6.56,6.56,0,0,0-6.51-5.57H409.05v22.54a6.91,6.91,0,0,1-13.82,0V253.1H319.82v22.54a6.91,6.91,0,1,1-13.82,0V253.1H291.45a6.56,6.56,0,0,0-6.51,5.57l0,.13L259.82,400.47A20.12,20.12,0,0,0,279.91,420H435.14a20.12,20.12,0,0,0,20.09-19.53Z"
          fill="currentColor"
        />
        <path d="M89.53,329.31H113v58.33H89.53Z" fill="currentColor" />
        <path d="M31.71,38.94h104V61.61H31.71Z" fill="currentColor" />
        <path
          d="M275.48,247a6.73,6.73,0,0,1-.31-2V119.5h-94V387.64h66.88L271.3,256.45A20.46,20.46,0,0,1,275.48,247Zm-71.19-81.16h46.3a6.91,6.91,0,1,1,0,13.81h-46.3a6.91,6.91,0,1,1,0-13.81Zm0,43.07h46.3a6.91,6.91,0,1,1,0,13.81h-46.3a6.91,6.91,0,1,1,0-13.81Zm20.29,143H204.29a6.91,6.91,0,1,1,0-13.81h20.29a6.91,6.91,0,1,1,0,13.81Zm7.71-44.14h-28a6.91,6.91,0,1,1,0-13.82h28a6.91,6.91,0,0,1,0,13.82Zm20.23-40.92H204.29a6.91,6.91,0,1,1,0-13.81h48.22a6.91,6.91,0,1,1,0,13.81Z"
          fill="currentColor"
        />
        <path
          d="M319.82,225.67a37.71,37.71,0,1,1,75.41,0v27.44H409V225.67a51.52,51.52,0,1,0-103,0v27.44h13.82Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
};

const HotelIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      style={{
        height: '30'
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 487.31 420"
        height="30"
      >
        <path
          d="M468.41,82.38H373.18a1.56,1.56,0,0,1-1.55-1.55V73.72a1.55,1.55,0,0,0-1.55-1.55h-13.2a1.54,1.54,0,0,1-1.55-1.55V3.14a1.55,1.55,0,0,0-1.55-1.55H340.31a1.55,1.55,0,0,0-1.55,1.55V80.83a1.56,1.56,0,0,1-1.55,1.55H325.06a1.55,1.55,0,0,1-1.55-1.55V73.72A1.55,1.55,0,0,0,322,72.17H307.44a1.54,1.54,0,0,1-1.55-1.55V48.5A1.54,1.54,0,0,1,307.44,47h9.37a1.55,1.55,0,0,0,1.55-1.55V36.84a1.54,1.54,0,0,0-1.55-1.55h-9.37a1.54,1.54,0,0,1-1.55-1.55V14.53A1.54,1.54,0,0,1,307.44,13H322a1.55,1.55,0,0,0,1.55-1.55V3.14A1.55,1.55,0,0,0,322,1.59h-31.1a1.56,1.56,0,0,0-1.55,1.55V80.83a1.55,1.55,0,0,1-1.55,1.55H264.23a1.56,1.56,0,0,1-1.55-1.55V15.53A1.55,1.55,0,0,1,264.23,14h8.7a1.55,1.55,0,0,0,1.55-1.55V3.14a1.56,1.56,0,0,0-1.55-1.55H235.64a1.55,1.55,0,0,0-1.55,1.55v9.29A1.54,1.54,0,0,0,235.64,14h8.92a1.54,1.54,0,0,1,1.55,1.55v65.3a1.55,1.55,0,0,1-1.55,1.55H214.37a1.55,1.55,0,0,1-1-2.7l.16-.15A21.39,21.39,0,0,0,218,73.17a31.48,31.48,0,0,0,2.48-7.9,53.28,53.28,0,0,0,.73-9.08V29.05q0-29.05-24-29T173.22,29.05V56.6a50.93,50.93,0,0,0,.75,9.06,30.61,30.61,0,0,0,2.5,7.81,20.6,20.6,0,0,0,4.44,6.19l0,0a1.54,1.54,0,0,1-1,2.69H156.74a1.56,1.56,0,0,1-1.55-1.55V3.14a1.55,1.55,0,0,0-1.55-1.55H140.08a1.55,1.55,0,0,0-1.55,1.55V33.65A1.56,1.56,0,0,1,137,35.2h-8.79a1.56,1.56,0,0,1-1.55-1.55V3.14a1.55,1.55,0,0,0-1.55-1.55H111.62a1.55,1.55,0,0,0-1.55,1.55V80.83a1.55,1.55,0,0,1-1.55,1.55H18.9A19,19,0,0,0,0,101.27V401.1A19,19,0,0,0,18.9,420H151.3a1.55,1.55,0,0,0,1.55-1.55V316.65a1.55,1.55,0,0,1,1.55-1.55H336.28a1.55,1.55,0,0,1,1.55,1.55v101.8a1.55,1.55,0,0,0,1.55,1.55h129a19,19,0,0,0,18.9-18.9V101.27A19,19,0,0,0,468.41,82.38ZM189.79,24.91a26.31,26.31,0,0,1,.3-4.12,19.26,19.26,0,0,1,1-3.83,6.48,6.48,0,0,1,2.28-3.05,6.31,6.31,0,0,1,3.78-1.11q7.43,0,7.42,12.11V60.33q0,12.08-7.42,12.07t-7.38-12.07ZM128.19,47H137a1.56,1.56,0,0,1,1.55,1.55V80.83A1.56,1.56,0,0,1,137,82.38h-8.79a1.56,1.56,0,0,1-1.55-1.55V48.54A1.56,1.56,0,0,1,128.19,47ZM112.47,290.25h-70a1.55,1.55,0,0,1-1.55-1.55v-70a1.55,1.55,0,0,1,1.55-1.55h70a1.54,1.54,0,0,1,1.55,1.55v70A1.54,1.54,0,0,1,112.47,290.25Zm0-95h-70a1.55,1.55,0,0,1-1.55-1.55v-70a1.56,1.56,0,0,1,1.55-1.55h70a1.55,1.55,0,0,1,1.55,1.55v70A1.54,1.54,0,0,1,112.47,195.25Zm111.91,95h-70a1.54,1.54,0,0,1-1.55-1.55v-70a1.54,1.54,0,0,1,1.55-1.55h70a1.55,1.55,0,0,1,1.55,1.55v70A1.55,1.55,0,0,1,224.38,290.25Zm0-95h-70a1.54,1.54,0,0,1-1.55-1.55v-70a1.55,1.55,0,0,1,1.55-1.55h70a1.56,1.56,0,0,1,1.55,1.55v70A1.55,1.55,0,0,1,224.38,195.25Zm111.9,95h-70a1.55,1.55,0,0,1-1.55-1.55v-70a1.55,1.55,0,0,1,1.55-1.55h70a1.54,1.54,0,0,1,1.55,1.55v70A1.54,1.54,0,0,1,336.28,290.25Zm0-95h-70a1.55,1.55,0,0,1-1.55-1.55v-70a1.56,1.56,0,0,1,1.55-1.55h70a1.55,1.55,0,0,1,1.55,1.55v70A1.54,1.54,0,0,1,336.28,195.25Zm111.91,95h-70a1.55,1.55,0,0,1-1.55-1.55v-70a1.55,1.55,0,0,1,1.55-1.55h70a1.54,1.54,0,0,1,1.55,1.55v70A1.54,1.54,0,0,1,448.19,290.25Zm0-95h-70a1.55,1.55,0,0,1-1.55-1.55v-70a1.56,1.56,0,0,1,1.55-1.55h70a1.55,1.55,0,0,1,1.55,1.55v70A1.54,1.54,0,0,1,448.19,195.25Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
};

const PoliticalOfficeIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      style={{
        height: '30'
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 402.5 420"
        height="30"
      >
        <path
          d="M376.25,367.5H367.5v-8.75a8.75,8.75,0,0,0-8.75-8.75H332.5V262.5h8.75a26.25,26.25,0,0,0,0-52.5H332A131.36,131.36,0,0,0,226.31,90,26,26,0,0,0,210,71.64V52.5h43.75a8.76,8.76,0,0,0,6.19-15l-11.3-11.3L259.94,15A8.76,8.76,0,0,0,253.75,0h-52.5a8.75,8.75,0,0,0-8.75,8.75V71.61A26.26,26.26,0,0,0,175.82,90,131.37,131.37,0,0,0,70.44,210H61.25a26.25,26.25,0,0,0,0,52.5H70V350H43.75A8.75,8.75,0,0,0,35,358.75v8.75H26.25A26.29,26.29,0,0,0,0,393.75v17.5A8.75,8.75,0,0,0,8.75,420h385a8.75,8.75,0,0,0,8.75-8.75v-17.5A26.29,26.29,0,0,0,376.25,367.5ZM105,350H87.5V262.5H105Zm35,0H122.5V262.5H140Zm35,0H157.5V262.5H175Zm35,0H192.5V262.5H210Zm35,0H227.5V262.5H245Zm35,0H262.5V262.5H280Zm35,0H297.5V262.5H315Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
};

const PlaceWorshipIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      style={{
        height: '30'
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 244.09 420"
        height="30"
      >
        <path
          d="M121.61,322.78a37.92,37.92,0,0,0-37.85,37.77V420h75.7V360.55A37.93,37.93,0,0,0,121.61,322.78Z"
          fill="currentColor"
        />
        <path
          d="M117.83,2,1.13,139.77A5.24,5.24,0,0,0,0,143V414.75A5.26,5.26,0,0,0,5.26,420H68.94V359.31c0-26.61,19.43-49.8,45.89-53.14a52.76,52.76,0,0,1,59.45,52.13V420h64.55a5.26,5.26,0,0,0,5.26-5.25V143a5.24,5.24,0,0,0-1.13-3.25L126.09,2A5.26,5.26,0,0,0,117.83,2Zm7,276.21a78.7,78.7,0,0,1-82.77-82.6c2-39.94,34.55-72.4,74.57-74.42a78.71,78.71,0,0,1,82.78,82.6C197.4,243.73,164.88,276.18,124.85,278.21Z"
          fill="currentColor"
        />
        <path
          d="M132.17,259.64A21.74,21.74,0,1,1,147,222a27.34,27.34,0,1,0-2.62,33.9A21.68,21.68,0,0,1,132.17,259.64Z"
          fill="currentColor"
        />
        <polygon
          points="140.55 229.68 142.44 235.51 148.58 235.51 143.62 239.1 145.51 244.93 140.55 241.33 135.59 244.93 137.48 239.1 132.52 235.51 138.65 235.51 140.55 229.68"
          fill="currentColor"
        />
        <path
          d="M118.06,161.93H102.5L94.67,148.4l-7.83,13.53H71.29l7.78,13.44-7.78,13.45H86.84l7.83,13.53,7.83-13.53h15.56l-7.78-13.45Zm-23.39-5.56,3.22,5.56H91.45Zm5.52,9.54,5.48,9.46-5.48,9.46h-11l-5.48-9.46,5.48-9.46Zm-22,0h6.34l-3.17,5.48Zm0,18.92,3.17-5.47,3.17,5.47Zm16.47,9.55-3.22-5.56h6.44Zm16.47-9.55H104.8l3.17-5.47Zm-6.34-18.92h6.34L108,171.39Z"
          fill="currentColor"
        />
        <polygon
          points="173.2 159.1 161.59 159.1 161.59 148.53 149.29 148.53 149.29 159.1 137.68 159.1 137.68 171.38 149.29 171.38 149.29 203.73 161.59 203.73 161.59 171.38 173.2 171.38 173.2 159.1"
          fill="currentColor"
        />
      </svg>
    </span>
  );
};

const OtherBuildingIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      style={{
        height: '30'
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 359.2 420"
        height="30"
      >
        <path
          d="M349.92,120.65,188.77,2.69a17,17,0,0,0-18.34,0L9.28,120.65A20.75,20.75,0,0,0,0,138.26V399.7C0,410.91,8.26,420,18.45,420h322.3c10.19,0,18.45-9.09,18.45-20.3V138.26A20.75,20.75,0,0,0,349.92,120.65ZM189.8,350.27H157.18V318.63H189.8Zm25.34-99.8a67.11,67.11,0,0,1-25.34,25.59V303.4H157.18V265.51a97.92,97.92,0,0,0,12.26-9.91,103.68,103.68,0,0,0,10.89-12.16,57,57,0,0,0,8-14.5,43.67,43.67,0,0,0,3-15.58q0-6.74-3.17-10.16t-9.13-3.41a9.1,9.1,0,0,0-8.25,4.44A20.47,20.47,0,0,0,168,215.31a41,41,0,0,0,1.86,12.11l-30.67,5.86a81.09,81.09,0,0,1-2.83-20.51q0-18.75,10.65-30.22t32-11.47q21.57,0,33.4,11.47t11.81,32.76A70.41,70.41,0,0,1,215.14,250.47Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
};

const DwellingOfficeIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      style={{
        height: '30'
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 95.43 98.32"
        height="30"
      >
        <path
          d="M92,0H46.07a3.49,3.49,0,0,0-3.48,3.49V22.35L1,48a2.15,2.15,0,0,0-.7,3l.11.18a2.15,2.15,0,0,0,2.95.7l4.44-2.74v45h0v4.18H92a3.5,3.5,0,0,0,3.48-3.48V3.49A3.5,3.5,0,0,0,92,0ZM12,94.14V46.55l30.59-18.9V47.11h-20a3.42,3.42,0,0,0-3.42,3.42v6.75a3.42,3.42,0,0,0,3.42,3.42h20V70H22.69a3.53,3.53,0,0,0-3.52,3.53v6.53a3.53,3.53,0,0,0,3.52,3.52h19.9V94.14Zm52.43-6.06H53.51V77.16H64.43Zm0-22.3H53.51V54.85H64.43Zm0-22.31H53.51V32.55H64.43Zm0-22.3H53.51V10.24H64.43ZM84.37,88.08H73.45V77.16H84.37Zm0-22.3H73.45V54.85H84.37Zm0-22.31H73.45V32.55H84.37Zm0-22.3H73.45V10.24H84.37Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
};

const LandIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      style={{
        height: '30'
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 443.38 420"
        height="30"
      >
        <path
          d="M0,204.34v46.42A280.84,280.84,0,0,1,66.75,420h74.57A254,254,0,0,0,0,204.34Z"
          fill="currentColor"
        />
        <path
          d="M207.53,178.5a281.43,281.43,0,0,1,78.89,55.66A279.16,279.16,0,0,1,368.47,420h74.58C436.59,291.72,335,188.11,207.53,178.5Z"
          fill="currentColor"
        />
        <path d="M0,420H40.74A255,255,0,0,0,0,294.13Z" fill="currentColor" />
        <path
          d="M348.25,201.75A284.09,284.09,0,0,1,387,234.16a281.34,281.34,0,0,1,56.39,80.48V178.1A255.57,255.57,0,0,0,348.25,201.75Z"
          fill="currentColor"
        />
        <path
          d="M6.17,178.49A281,281,0,0,1,118.39,274a279.3,279.3,0,0,1,48.93,146H241.9C235.43,291.65,133.71,188,6.17,178.49Z"
          fill="currentColor"
        />
        <path
          d="M107,178.5a281.29,281.29,0,0,1,78.89,55.66A279.17,279.17,0,0,1,267.9,420h74.57C336,291.72,234.39,188.11,107,178.5Z"
          fill="currentColor"
        />
        <path
          d="M68.13,92.78c0,.24,0,.47,0,.71,0,15.38,14.12,27.84,31.55,27.84.44,0,.88,0,1.31,0V172h24.87V121.29c.54,0,1.09,0,1.65,0,17.42,0,31.55-12.46,31.55-27.84,0-.24,0-.47,0-.71,7.34-6.37,11.9-15.23,11.9-25a31.84,31.84,0,0,0-5.31-17.5,28.21,28.21,0,0,0,.56-5.54c0-13.88-10-25.71-23.91-30.24C134.51,5.45,124.51,0,113.57,0S92.64,5.45,84.89,14.47C70.94,19,61,30.83,61,44.71a29,29,0,0,0,.55,5.54,31.92,31.92,0,0,0-5.3,17.5C56.23,77.55,60.79,86.41,68.13,92.78Z"
          fill="currentColor"
        />
        <path
          d="M249.54,92.78c0,.24,0,.47,0,.71,0,15.38,14.13,27.84,31.56,27.84.43,0,.87,0,1.3,0v65.12l24.87,10.26V121.29c.55,0,1.1,0,1.65,0,17.43,0,31.55-12.46,31.55-27.84,0-.24,0-.47,0-.71,7.34-6.37,11.9-15.23,11.9-25a31.92,31.92,0,0,0-5.3-17.5,29,29,0,0,0,.55-5.54c0-13.88-10-25.71-23.91-30.24C315.92,5.45,305.92,0,295,0S274.05,5.45,266.3,14.47c-14,4.53-23.9,16.36-23.9,30.24a28.21,28.21,0,0,0,.55,5.54,31.83,31.83,0,0,0-5.3,17.5C237.65,77.55,242.2,86.41,249.54,92.78Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
};

const DepartmentStoreIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      style={{
        height: '30'
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 477.86 420"
        height="30"
      >
        <path
          d="M154.93,280H407.87a14,14,0,0,0,13.45-10.16l56-196A14,14,0,0,0,463.87,56H122.61l-10-45A14,14,0,0,0,98.93,0H14a14,14,0,0,0,0,28H87.7l50.55,227.5A42,42,0,0,0,154.93,336H407.87a14,14,0,0,0,0-28H154.93a14,14,0,0,1,0-28Z"
          fill="currentColor"
        />
        <path
          d="M140.93,378a42,42,0,1,0,42-42A42,42,0,0,0,140.93,378Z"
          fill="currentColor"
        />
        <path
          d="M337.87,378a42,42,0,1,0,42-42A42,42,0,0,0,337.87,378Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
};

const MachineBreakdownIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      style={{
        height: '30'
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 366 363.95"
        height="30"
      >
        <rect width="40.02" height="308.96" rx="10" fill="currentColor" />
        <rect
          x="325.98"
          width="40.02"
          height="308.96"
          rx="10"
          fill="currentColor"
        />
        <polygon
          points="166.48 242.02 40.02 242.02 40.02 68.66 166.13 68.23 147.27 96.55 185 132.6 143.08 192.67 166.48 242.02"
          fill="currentColor"
        />
        <polygon
          points="198.45 242.02 326.34 241.59 326.34 67.8 198.09 67.8 178.96 95.69 217.93 131.74 174 192.67 198.45 242.02"
          fill="currentColor"
        />
        <circle cx="163.64" cy="302.85" r="21.05" fill="currentColor" />
        <path
          d="M163.64,267.49s.42,2.53-10.95,14.73-10.1,20.63-10.1,20.63h42.06s1.26-8.42-10.11-20.63c-9.51-10.21-10.77-13.65-10.92-14.5a.81.81,0,0,1,0-.23"
          fill="currentColor"
        />
        <circle cx="215.51" cy="342.9" r="21.05" fill="currentColor" />
        <path
          d="M215.51,307.54s.42,2.52-10.95,14.73-10.1,20.63-10.1,20.63h42.06s1.26-8.42-10.1-20.63c-9.51-10.21-10.77-13.65-10.93-14.5a.81.81,0,0,1,0-.23"
          fill="currentColor"
        />
      </svg>
    </span>
  );
};

const IndoorPoolIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      style={{
        height: '30'
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 493.92 425.67"
        height="30"
      >
        <path
          d="M247,56.67s201,179,210,187,15,0,15,0,11-14,19-24-3-16-3-16-200-180-215-193c0,0-25.08-24-52.08,0-14.84,13.18-215,193-215,193s-11,6-3,16,19,24,19,24,6,8,15,0,210-187,210-187"
          fill="currentColor"
        />
        <path
          d="M246.92,84.67l-176,156v159s0,21,19,21h157"
          fill="none"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeWidth="10"
        />
        <path
          d="M246.92,420.67h157c19,0,19-21,19-21v-159l-176-156-3.36,3"
          fill="none"
          stroke="currentColor"
          strokeMiterlimit="10px"
          strokeWidth="10px"
        />
        <path
          d="M70.92,297.06s32-28.39,64-.39,68,2,68,2,32-34,70-11c0,0,35,21,55,18s38-18,38-18,24-24,56-1l1,.54V397.67s0,23-18,23H92.29s-21.37,2.23-21.37-21.89Z"
          fill="currentColor"
        />
        <path
          d="M170.92,220.27s0-24.55,24.54-24.55,22.31,24.55,22.31,24.55v100.4"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="11px"
        />
        <path
          d="M243.56,220.77s0-24.55,24.54-24.55,22.32,24.55,22.32,24.55v100.4"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="11px"
        />
        <line
          x1="217.82"
          y1="240.06"
          x2="290.42"
          y2="240.06"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="11px"
        />
        <line
          x1="290.42"
          y1="269.1"
          x2="217.77"
          y2="269.1"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="11px"
        />
        <line
          x1="290.42"
          y1="297.81"
          x2="217.77"
          y2="297.81"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="6px"
        />
      </svg>
    </span>
  );
};

const OutdoorPoolIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      style={{
        height: '30'
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 352 411.05"
        height="30"
      >
        <path
          d="M0,287.39S32,259,64,287s68,2,68,2,32-34,70-11c0,0,35,21,55,18s38-18,38-18,24-24,56-1l1,.54V388s0,23-18,23H21.37S0,413.23,0,389.12Z"
          fill="currentColor"
        />
        <line
          y1="164"
          x2="352"
          y2="164"
          fill="none"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeWidth="6px"
        />
        <line
          y1="175.5"
          x2="352"
          y2="175.5"
          fill="none"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeWidth="6px"
        />
        <path
          d="M295.76,161.81s0-38.81-40.6-38.81-36.91,38.81-36.91,38.81V320.59"
          fill="none"
          stroke="currentColor"
          strokeLinejoin="round"
          strokeWidth="15px"
        />
        <path
          d="M175.59,162.6s0-38.81-40.6-38.81-36.9,38.81-36.9,38.81V321.38"
          fill="none"
          stroke="currentColor"
          strokeLinejoin="round"
          strokeWidth="15px"
        />
        <line
          x1="218.17"
          y1="211.12"
          x2="98.09"
          y2="211.12"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="15px"
        />
        <line
          x1="98.09"
          y1="257.04"
          x2="218.25"
          y2="257.04"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="15px"
        />
        <line
          x1="98.09"
          y1="302.44"
          x2="218.25"
          y2="302.44"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="14px"
        />
        <circle cx="66.73" cy="48.67" r="22.09" fill="currentColor" />
        <line
          x1="66.73"
          y1="4"
          x2="66.73"
          y2="13.89"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="8px"
        />
        <line
          x1="66.73"
          y1="83.61"
          x2="66.73"
          y2="93.5"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="8px"
        />
        <line
          x1="112.16"
          y1="48.48"
          x2="102.27"
          y2="48.48"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="8px"
        />
        <line
          x1="32.55"
          y1="48.48"
          x2="22.66"
          y2="48.48"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="8px"
        />
        <line
          x1="100.53"
          y1="20.71"
          x2="93.1"
          y2="27.24"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="8px"
        />
        <line
          x1="40.76"
          y1="73.3"
          x2="33.33"
          y2="79.83"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="8px"
        />
        <line
          x1="97.14"
          y1="84.2"
          x2="90.61"
          y2="76.77"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="8px"
        />
        <line
          x1="44.56"
          y1="24.43"
          x2="38.02"
          y2="17"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="8px"
        />
      </svg>
    </span>
  );
};

const SolarPanelIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      style={{
        height: '30'
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 363.5 333.93"
        height="30"
      >
        <polyline
          points="349 42.93 295.04 42.93 146.67 42.93 74.5 330.93 276.83 330.93 348.5 42.93"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="6px"
        />
        <line
          x1="299.5"
          y1="42.93"
          x2="225.51"
          y2="330.93"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="6px"
        />
        <line
          x1="243.51"
          y1="42.51"
          x2="169.52"
          y2="330.51"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="6px"
        />
        <line
          x1="188.51"
          y1="42.51"
          x2="114.52"
          y2="330.51"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="6px"
        />
        <line
          x1="86.35"
          y1="273.93"
          x2="288.67"
          y2="273.93"
          fill="none"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeWidth="6px"
        />
        <line
          x1="130.35"
          y1="102.93"
          x2="332.67"
          y2="102.93"
          fill="none"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeWidth="6px"
        />
        <line
          x1="118.35"
          y1="161.93"
          x2="320.67"
          y2="161.93"
          fill="none"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeWidth="6px"
        />
        <line
          x1="103.35"
          y1="216.93"
          x2="305.67"
          y2="216.93"
          fill="none"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeWidth="6px"
        />
        <polygon
          points="349.5 42.43 277.5 331.43 299.5 331.43 363.5 60.49 349.5 42.43"
          fill="currentColor"
        />
        <circle cx="52.88" cy="53.54" r="24.5" fill="currentColor" />
        <line
          x1="52.88"
          y1="4"
          x2="52.88"
          y2="14.97"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="8px"
        />
        <line
          x1="52.88"
          y1="92.29"
          x2="52.88"
          y2="103.26"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="8px"
        />
        <line
          x1="103.26"
          y1="53.33"
          x2="92.29"
          y2="53.33"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="8px"
        />
        <line
          x1="14.97"
          y1="53.33"
          x2="4"
          y2="53.33"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="8px"
        />
        <line
          x1="90.36"
          y1="22.53"
          x2="82.13"
          y2="29.78"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="8px"
        />
        <line
          x1="24.07"
          y1="80.85"
          x2="15.84"
          y2="88.1"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="8px"
        />
        <line
          x1="86.61"
          y1="92.95"
          x2="79.36"
          y2="84.71"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="8px"
        />
        <line
          x1="28.29"
          y1="26.66"
          x2="21.04"
          y2="18.42"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="8px"
        />
      </svg>
    </span>
  );
};

const VerandaIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      style={{
        height: '30'
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 599.29 416.07"
        height="30"
      >
        <circle cx="496.87" cy="99.29" r="33.75" fill="currentColor" />
        <line
          x1="496.87"
          y1="31.04"
          x2="496.87"
          y2="46.15"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="8px"
        />
        <line
          x1="496.87"
          y1="152.68"
          x2="496.87"
          y2="167.79"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="8px"
        />
        <line
          x1="566.29"
          y1="99"
          x2="551.18"
          y2="99"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="8px"
        />
        <line
          x1="444.65"
          y1="99"
          x2="429.54"
          y2="99"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="8px"
        />
        <line
          x1="548.52"
          y1="56.58"
          x2="537.17"
          y2="66.56"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="8px"
        />
        <line
          x1="457.19"
          y1="136.92"
          x2="445.84"
          y2="146.9"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="8px"
        />
        <line
          x1="543.34"
          y1="153.58"
          x2="533.36"
          y2="142.24"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="8px"
        />
        <line
          x1="463"
          y1="62.26"
          x2="453.01"
          y2="50.91"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="8px"
        />
        <path
          d="M205.28,47.27,29.61,218a5.84,5.84,0,0,1-.15,1.08,5.94,5.94,0,0,0-.16,1.08V393a24.26,24.26,0,0,0,5.81,16.21C39,413.74,43.56,416,48.86,416H166.17V277.75H244.4V416H361.71q7.95,0,13.75-6.85A24.23,24.23,0,0,0,381.27,393V220.13A5.84,5.84,0,0,0,381,218Z"
          fill="currentColor"
        />
        <path
          d="M407.46,183.75l-55.73-53.51v-120a10,10,0,0,0-2.3-6.76A7.38,7.38,0,0,0,343.58.89H294.72a7.39,7.39,0,0,0-5.85,2.64,9.94,9.94,0,0,0-2.29,6.76V67.62l-62.09-60a28.3,28.3,0,0,0-38.68,0L2.83,183.75A9,9,0,0,0,0,190.06,10.59,10.59,0,0,0,1.81,197l15.78,21.75A8.44,8.44,0,0,0,22.93,222,8.59,8.59,0,0,0,29,219.91L205.14,50.27,381.25,219.91a7.19,7.19,0,0,0,5.34,2.05h.77a8.41,8.41,0,0,0,5.34-3.23L408.48,197a10.56,10.56,0,0,0,1.78-6.91A9.06,9.06,0,0,0,407.46,183.75Z"
          fill="currentColor"
        />
        <rect
          x="376.54"
          y="261.5"
          width="216.17"
          height="144.99"
          fill="none"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeWidth="8px"
        />
        <polyline
          points="376.54 261.26 376.54 219 593.03 261.26"
          fill="none"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeWidth="8px"
        />
        <line
          x1="376.54"
          y1="290.31"
          x2="592.38"
          y2="290.31"
          fill="none"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeWidth="8px"
        />
        <line
          x1="450.54"
          y1="290.31"
          x2="450.54"
          y2="406.49"
          fill="none"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeWidth="8px"
        />
        <line
          x1="522.03"
          y1="290.31"
          x2="522.03"
          y2="406.49"
          fill="none"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeWidth="8px"
        />
        <polyline
          points="586.24 406.77 599.29 406.77 599.29 416.07 360.29 416.07 360.97 406.77"
          fill="currentColor"
        />
      </svg>
    </span>
  );
};

const UnoccupiedIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      style={{
        height: '30'
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 359.2 420"
        height="30"
      >
        <path
          d="M349.92,120.65,188.77,2.69a17,17,0,0,0-18.34,0L9.28,120.65A20.75,20.75,0,0,0,0,138.26V399.7C0,410.91,8.26,420,18.45,420h322.3c10.19,0,18.45-9.09,18.45-20.3V138.26A20.75,20.75,0,0,0,349.92,120.65ZM277.35,255.18A97.71,97.71,0,0,1,119.2,332l-35,35.85-14.31-14,35-35.8A97.7,97.7,0,0,1,240.73,179l33.54-34.34,14.31,14L255,193A97.27,97.27,0,0,1,277.35,255.18Z"
          fill="currentColor"
        />
        <path
          d="M133.27,317.59A77.7,77.7,0,0,0,240.88,207.42Z"
          fill="currentColor"
        />
        <path
          d="M179.6,177.43a77.69,77.69,0,0,0-60.7,126.26L226.67,193.35A77.34,77.34,0,0,0,179.6,177.43Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
};

const ConstructionIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      style={{
        height: '30'
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 336.96 402.19"
        height="30"
      >
        <rect
          y="347.6"
          width="103.21"
          height="54.59"
          rx="8"
          fill="currentColor"
        />
        <rect
          x="116.88"
          y="347.6"
          width="103.21"
          height="54.59"
          rx="8"
          fill="currentColor"
        />
        <rect
          x="233.75"
          y="347.6"
          width="103.21"
          height="54.59"
          rx="8"
          fill="currentColor"
        />
        <rect
          x="58.44"
          y="282.36"
          width="103.21"
          height="54.59"
          rx="8"
          fill="currentColor"
        />
        <rect
          x="175.31"
          y="282.36"
          width="103.21"
          height="54.59"
          rx="8"
          fill="currentColor"
        />
        <rect
          x="116.88"
          y="217.12"
          width="103.21"
          height="54.59"
          rx="8"
          fill="currentColor"
        />
        <path
          d="M193.53,73S178,81.73,179.05,94.31a163.43,163.43,0,0,0,2.37,18.94s.83,9.65-4.6,11.28-36.7,1.63-36.7,1.63S85.17,166.63,62.78,197.7c0,0,91.21-6,149.17-39.2,0,0-6.74-15.27-24.8-32.4,0,0,3.1-1.37,1.75-11.56a132.26,132.26,0,0,1-1-19.68s.75-10.14,12.49-14.09c0,0-.6,3.27,3.66,1.87s75.61-35.8,84.71-42.46,15-15.45,8.57-28.51S282-2.35,273,3.21s-68.2,49.7-78.16,63.23C194.85,66.44,191,71.23,193.53,73Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
};

const ConstructionLongIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      style={{
        height: '30'
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 336.96 384.69"
        height="30"
      >
        <rect
          y="264.86"
          width="103.21"
          height="54.59"
          rx="8"
          fill="currentColor"
        />
        <rect
          x="116.88"
          y="264.86"
          width="103.21"
          height="54.59"
          rx="8"
          fill="currentColor"
        />
        <rect
          x="233.75"
          y="264.86"
          width="103.21"
          height="54.59"
          rx="8"
          fill="currentColor"
        />
        <rect
          y="330.1"
          width="103.21"
          height="54.59"
          rx="8"
          fill="currentColor"
        />
        <rect
          x="116.88"
          y="330.1"
          width="103.21"
          height="54.59"
          rx="8"
          fill="currentColor"
        />
        <rect
          x="233.75"
          y="330.1"
          width="103.21"
          height="54.59"
          rx="8"
          fill="currentColor"
        />
        <rect
          x="58.44"
          y="199.62"
          width="103.21"
          height="54.59"
          rx="8"
          fill="currentColor"
        />
        <rect
          x="175.31"
          y="199.62"
          width="103.21"
          height="54.59"
          rx="8"
          fill="currentColor"
        />
        <rect
          x="116.88"
          y="134.38"
          width="103.21"
          height="54.59"
          rx="8"
          fill="currentColor"
        />
        <path
          d="M103.87,109.37V81.06H75.34V61.52h28.53V33.21h19V61.52H151.5V81.06H122.89v28.31Z"
          fill="currentColor"
        />
        <path
          d="M227.89,109.37V87.45H183.31V69.17L230.56,0H248.1V69.1h13.52V87.45H248.1v21.92Zm0-40.27V31.87l-25,37.23Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
};

export {
  FamilyIcon,
  SingleParentIcon,
  SoloIcon,
  PersonIcon,
  EntityIcon,
  StandardIcon,
  StandingIcon,
  AtypicalIcon,
  DilapidatedIcon,
  FurnishedIcon,
  UnfurnishedIcon,
  OtherIcon,
  HouseIcon,
  ApartmentIcon,
  OfficeIcon,
  PremisesIcon,
  HangarIcon,
  IndustrialIcon,
  CommercialIcon,
  CommercialCellIcon,
  ShoppingArcadeIcon,
  HotelIcon,
  PoliticalOfficeIcon,
  PlaceWorshipIcon,
  OtherBuildingIcon,
  DwellingOfficeIcon,
  LandIcon,
  DepartmentStoreIcon,
  MachineBreakdownIcon,
  IndoorPoolIcon,
  OutdoorPoolIcon,
  SolarPanelIcon,
  VerandaIcon,
  UnoccupiedIcon,
  ConstructionIcon,
  ConstructionLongIcon
};
